// extracted by mini-css-extract-plugin
module.exports = {"icon":"SortArrows-module__icon___pD8jx","flipped":"SortArrows-module__flipped___2589X","single":"SortArrows-module__single___2XQyP"};